<script setup>
import { computed } from 'vue'
import { RadioGroupItem, useForwardProps } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  id: { type: String, required: false },
  value: { type: String, required: false },
  disabled: { type: Boolean, required: false },
  required: { type: Boolean, required: false },
  name: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RadioGroupItem v-bind="forwardedProps" :class="['form-check-input', props.class]" />
</template>

<style lang="scss" scoped>
.form-check-input {
  border-radius: 50%;
  padding: 0;

  &[data-state='checked'] {
    --gu-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");

    background-color: var(--gu-primary);
    border-color: var(--gu-primary);
  }
}
</style>
